import { ReactNode, PropsWithChildren } from 'react';
import { PaperProps } from '../../../../../../shared/library/Paper';
import {
  StyledWrapper,
  StyledBadgeWrapper,
  StyledShiftedContentWrapper,
} from './styles';

export interface CardWrapperProps extends PaperProps {
  badge?: ReactNode;
  shiftedContent?: ReactNode;
}

export default function CardWrapper(
  props: PropsWithChildren<CardWrapperProps>,
) {
  const { badge, shiftedContent, children, ...paperProps } = props;

  return (
    <StyledWrapper {...paperProps}>
      {badge && <StyledBadgeWrapper>{badge}</StyledBadgeWrapper>}
      <div>{children}</div>
      {shiftedContent && (
        <StyledShiftedContentWrapper>
          {shiftedContent}
        </StyledShiftedContentWrapper>
      )}
    </StyledWrapper>
  );
}
